import { store } from '@/decorators/store';
import { Gender } from '@/entities/Gender';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'Gender' })
export class GenderStore extends AbstractEntityStore<Gender> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'description';
  protected entityValueKey = 'description';
}
